module.exports = __webpack_public_path__ + "static/img/slide_5.6f9ae12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/slide_5.png
// module id = AEC+
// module chunks = 0